<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row v-if="role == 'booster'">
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding v-if="totalUsers > 0" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
      v-if="(!users || users.length == 0) && usersInfo.currentPage == 1 && !loadingData && search == null"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyPeopleInActivityTitle')"
          :page-text="$t('emptyPeopleInActivityText')"
          page-image="image1"
        />
      </v-col>
    </v-row>

    <v-row
      v-else
      align="center"
      class="mx-auto"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col 
                cols="11"
                class="d-flex justify-left align-center "
              >
                <v-avatar
                  size="38"
                  class="ml-4 mr-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id && spaceOwnerEmail != user.attributes.email"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-activity"
                      router 
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromActivity'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveUserFromActivity'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                align="center"
                class="d-flex justify-center align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>

              <v-col
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </div>
              </v-col>

              <v-col
                md="5"
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id && spaceOwnerEmail != user.attributes.email"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-activity"
                      router 
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromActivity'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveUserFromActivity'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
    <PlusButtonWithLink
      data-testid="add-boosters-button"
      rounded="xxl"
      :link="link"
      :hide-for-free-plan="productPlan.attributes && productPlan.attributes.name == 'Free'"
    />
    <ConfirmationDialog 
      v-if="dialogVisibleRemoveUser"
      ref="confirmationDialogRemoveUser"
      :visible="dialogVisibleRemoveUser" 
      :cd-title="confirmationDialogTitle" 
      :cd-text="confirmationDialogText" 
      :cd-submit-btn="confirmationDialogSubmitBtn" 
      :cd-cancel-btn="confirmationDialogCancelBtn" 
      data-testid="confirmation-dialog-user" 
      @close="dialogVisibleRemoveUser=false"
      @proceedSubmit="removeUser(selectedUserForRemoving)"
    /> 
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getBoostersInActivity, removeUserFromActivity,searchPeopleInActivityBoosters } from '../../api/activityApi'
import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import EmptyPage from '../../components/EmptyPage'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import SearchBarExpanding from '../../components/SearchBarExpanding'

export default {
    components: {
        Pagination,
        PlusButtonWithLink,
        EmptyPage,
        ConfirmationDialog,
        AlertMessages,
        SearchBarExpanding
    },
    props: ['role'],
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: {
                currentPage: 1,
                total: 0,
            },
            userId: window.$cookies.get('id'),
            activityId: this.$route.params.id,
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'',
            alertType:'',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            loadingData: false,
            dialogVisibleRemoveUser: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            link: {title: i18n.t('invitePeopleTitle'), route: '/activity/' + this.$route.params.id + '/owners/add'},
            search: null,
            paginationKey: '',
            spaceOwnerEmail: localStorage.space ? JSON.parse(localStorage.space).owner_email : '',
            totalUsers: 0
        }
    },
    computed: {
      productPlan() {
        return this.$store.state.productPlan;
      },
    },
    async created(){
        this.loadingData = true
        await this.fetchOwnersInActivity()
        if(this.$route.params.boostersAddedInActivity){
            this.alertMsg = i18n.t('addActivityBoostersSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        this.loadingData = false
    },
    methods:{
         async searchPeople(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchPeopleInActivityBoosters(this.activityId,keyword,this.pageNumber, this.size)
                  if(response){
                      if(response.status == 200){
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.searchPeople(keyword)
                        }else {
                            this.usersInfo = response.data.meta
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.usersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchOwnersInActivity()
          this.search = null
          this.paginationKey = Date.now()
          return
        },
        handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchOwnersInActivity()
            }else {
              this.searchPeople(this.search)
            }
        },
        async fetchOwnersInActivity(){
            try {
                const response = await getBoostersInActivity(this.activityId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.fetchOwnersInActivity()
                        }else {
                            this.usersInfo = response.data.meta
                            this.totalUsers = response.data.meta.total
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async removeUser(email){
            this.dialogVisibleRemoveUser = false
            try{
                let data = {
                    data: {
                        type: "activity-users",
                        attributes: {
                            user_email: email
                        },
                    }
                }
                const response = await removeUserFromActivity(this.activityId, data)
                if(response.status == 200) {
                    if(this.search == null){
                        await this.fetchOwnersInActivity()
                    }else {
                        await this.searchPeople(this.search)
                    }
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeUserFromActivitySuccess')
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        }
    },
}
</script>
